export default __webpack_public_path__ + "static/media/memberBg3.45266588.png";